import React, { useEffect, useState } from 'react';
import Modal from "../../../component/Global/Modal";
import BOM from "@system/config/bom";
import ProductRepository from 'src/repository/ProductRepository';
import System from 'src/helper/system';
import { useBOMStore } from 'src/hooks/bom';
import { useCartStore } from 'src/hooks/cart';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import Constants from 'src/support/Constants';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useBOMProjectStore } from "../../../hooks/bom_project";
import { useProductPricingStore } from 'src/hooks/productPricing';
import { useProductInventoryStore } from 'src/hooks/productInventory';
import NavigateToPDP from 'src/component/Global/Product/NavigateToPDP';
import CartCommon from "src/component/Global/Cart/Common";

const AddedToBomPopup = (props) => {
    const [status, SetStatus] = useState(false);
    const [productData, setProductData] = useState(false);
    const [{ AddedToBomPopup }, { }, { }] = useDOMAttachToSystemStore();
    const [{ CART_BEFORE_TO_SEND_SERVER, CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER, }, { }, { },] = useCartStore();
    let { single_product, swap_mode, bomId, bomDetailId } = AddedToBomPopup && AddedToBomPopup.data;
    const [{ bom_project_list }, { }, { }] = useBOMProjectStore();
    const [{ bom_detail_by_bom_id, bom_detail_by_bom_id_type }, { }, { add_part_to_bom, swap_part_number },] = useBOMStore();

    const bom_id = System.getParams().bomId;

    const [, { get_inventory_by_id }, { }] = useProductInventoryStore();
    const [{ pricingList }, { }, { }] = useProductPricingStore();

    useEffect(() => {
        const customerPartNumber = CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[single_product?.ItemNumber]?.CUSTOMER_PART_NUMBER;
        async function fetchHere() {
            if (AddedToBomPopup) {
                const ErpPartNumber = single_product.ItemNumber;
                await getProductData(ErpPartNumber);
                let params = {};

                params.LifeCycleRisk = single_product.LifeCycleRisk
                    ? single_product.LifeCycleRisk
                    : "";
                params.partNumber = single_product.ERPMFRPartNumber;
                params.erpPartNumber = single_product.ERPPartNumber;
                params.manufacturerPartNumber = single_product.ERPMFRPartNumber;
                params.itemNumber = single_product.ItemNumber;
                params.customerPartNumber = customerPartNumber;
                params.quantity = getLatestQuantity();
                params.cpnType = params.customerPartNumber
                    ? Constants.cpnTypes.CPN
                    : Constants.cpnTypes.MANUALCPN;
                params.manualCPN = "";

                if (swap_mode === "yes" && bomDetailId && bomId) {
                    params.bomDetailId = bomDetailId;
                    params.bomId = bomId;
                    params.designWinFlag = single_product?.DesignWinFlag;
                    await swap_part_number(params);
                } else {
                    params.bomIds = [bomId];
                    params.fromCart = false;
                    await add_part_to_bom(params);
                }
                SetStatus(true);
            }
        }

        fetchHere();
    }, [AddedToBomPopup]);

    const getLatestQuantity = () => {
        if (CART_BEFORE_TO_SEND_SERVER && single_product?.ItemNumber &&
            CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber] &&
            CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber].quantityAddToCart !== undefined
        ) {
            return CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber].quantityAddToCart;
        }
        return single_product.QtyMin !== null ? single_product.QtyMin : 0;
    };

    const getProductData = async (ErpPartNumber) => {
        let res =
            await new ProductRepository().fetchProductObjectByERPPartNumbersNew(
                ErpPartNumber,
                true
            );
        setProductData(res[ErpPartNumber]);
        noMatchesEvent(res[ErpPartNumber]);
    };

    //By Ramya Kannan - [Bom No matches resolved - Adobe script]
    function noMatchesEvent(prodData) {
        let prodDetails = { ...prodData };
        let getBomDetails = bom_detail_by_bom_id;
        let bomDetails = { ...getBomDetails };
        if (bom_project_list) {
            bomDetails.projectName =
                bom_project_list[bom_detail_by_bom_id.projectId]?.projectName;
        }
        bomDetails.exactMatchCount = bom_detail_by_bom_id_type?.Exact?.count;
        bomDetails.nomatchCount = bom_detail_by_bom_id_type?.NoMatch?.count;
        bomDetails.multipleMatchCount = bom_detail_by_bom_id_type?.Multiple?.count;

        prodDetails.qas = getInventory(prodDetails?.ERPPartNumber)?.qas;
        console.log("Ramya", prodDetails.assets.pricing[0])
        prodDetails.priceSource = getPricing(
            prodDetails.ERPMFRPartNumber || prodDetails.erpMfrPartNumber,
            prodDetails.ERPPartNumber,
            prodDetails.ERPPartNumberModified
        )[0]?.priceSource;
        prodDetails.subtotal =
            getPricing(
                prodDetails.ERPMFRPartNumber || prodDetails.erpMfrPartNumber,
                prodDetails.ERPPartNumber,
                prodDetails.ERPPartNumberModified
            )[0]?.marketPrice * 1000;

        prodDetails.Quantity = getLatestQuantity();

        localStorage.setItem("adobeEventType", "bomNoMatchesResolved");
        if (Object.keys(prodDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ prodDetails, bomDetails });
        }
    }

    const onHide = (action = true) => {
        SetStatus(false);
    };

    const getInventory = (ERPPartNumber) => {
            return get_inventory_by_id(ERPPartNumber)
    };
    const getPricing = (ERPMFRPartNumber, ERPPartNumber, ERPPartNumberModified) => {
        ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
        if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
            return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
        }
        return [];
    };

    // const getLatestPrice = () => {
    //     if (productData?.assets?.pricing && productData?.assets?.pricing?.length > 0) {
    //         return productData?.assets?.pricing.find(x => x.demandQuantityOut === getLatestQuantity())?.marketPrice || 0;
    //     }
    //     return 0
    // }

    const getLatestPrice = () => {
        let marketPrice = 0;
        if (productData?.assets?.pricing && productData?.assets?.pricing?.length > 0) {
            try {
                marketPrice = new CartCommon().getCurrentPriceByQuantityAndPriceArray(productData?.assets?.pricing, getLatestQuantity()).marketPrice;
            } catch (e) {
            }
        }
        return marketPrice;
    }

    return (
        <>
            <Modal
                show={status}
                onHide={() => {
                    onHide();
                }}
            >
                <div className="avnet-modal modal-800">
                    <div className="avnet-modal-inner">
                        <button
                            type="button"
                            className="close py-3"
                            data-dismiss="modal"
                            onClick={() => {
                                onHide();
                            }}
                        >
                            ×
                        </button>
                        <div className="bs5 modal-header border-0">
                            <h3 className="modal-title m-auto" id="exampleModalLabel">
                                Added to your BOM
                            </h3>
                        </div>
                        <div className="modal-body">
                            <p className="text-center mb-4">
                                This item has been added to your “Exact Matches”
                            </p>
                            {productData !== undefined &&
                                Object.keys(productData).length > 0 && (
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="bg-grey2">Product</th>
                                                <th className="bg-grey2">Manufacturer</th>
                                                <th className="bg-grey2">Quantity</th>
                                                <th className="bg-grey2">Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <NavigateToPDP data={{
                                                        ManufacturerName: productData?.ManufacturerName,
                                                        ERPMFRPartNumber: productData?.ERPMFRPartNumber,
                                                        ItemNumber: productData?.ItemNumber,
                                                    }} >
                                                        {productData.ERPMFRPartNumber}
                                                    </NavigateToPDP>
                                                </td>
                                                <td className="font-bold">
                                                    {productData.ManufacturerName}
                                                </td>
                                                <td className="font-bold">{getLatestQuantity()}</td>
                                                {productData.assets.pricing !== undefined &&
                                                    productData.assets.pricing[0] !== undefined &&
                                                    productData.assets.pricing[0].marketPrice !==
                                                    undefined && (
                                                        <td className="font-bold">
                                                            {window.mcs}{" "}
                                                            {getLatestPrice()}{" "}
                                                        </td>
                                                    )}
                                            </tr>
                                        </tbody>
                                    </table>
                                )}
                        </div>
                        <div className="modal-footer d-flex justify-content-center">
                            <button
                                type="button"
                                className="bs5 btn btn-secondary w145"
                                onClick={() => {
                                    onHide();
                                }}
                            >
                                CLOSE
                            </button>
                            <button
                                type="button"
                                className="bs5 btn btn-primary w145"
                                onClick={() => {
                                    window.location.href = BOM.getBomDetailByIdRouteURL(bom_id, {
                                        go: System.getParams().go,
                                    });
                                }}
                            >
                                Return to Bom
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default AddedToBomPopup;